import { type GoogleProtobufTimestamp } from "../../gql-generated/types";

import { truncateDateToUTC12AMTime } from "./truncateDateToUTC12AMTime";

export interface StartEndTimestamp {
    startTime: GoogleProtobufTimestamp | null;
    endTime: GoogleProtobufTimestamp | null;
}

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

/**
 *
 * @param rangeDays
 * @param daysShiftEnd - accepts postive and negative values
 * positive values mean shift to the future
 * negative values mean shift to the past
 *
 * @param daysShiftStart- accepts postive and negative values
 * positive values mean shift to the future
 * negative values mean shift to the past
 *
 */
export const makeUTCStartEndTimestamp = (
    rangeDays: number | undefined,
    daysShiftEnd = 0,
    daysShiftStart = 0,
): StartEndTimestamp => {
    if (!rangeDays) {
        return { startTime: null, endTime: null };
    }

    let endTimestamp = truncateDateToUTC12AMTime(new Date());
    endTimestamp += daysShiftEnd * ONE_DAY_IN_MS;

    let startTimestamp = endTimestamp - rangeDays * ONE_DAY_IN_MS;
    startTimestamp += daysShiftStart * ONE_DAY_IN_MS;

    return {
        startTime: {
            seconds: Math.round(startTimestamp / 1000),
            nanos: 0,
        },
        endTime: {
            seconds: Math.round(endTimestamp / 1000),
            nanos: 0,
        },
    };
};

export const makeUTCTimestampWithStart = (rangeDays: number | undefined, startDate: Date | null): StartEndTimestamp => {
    if (!rangeDays || !startDate) {
        return { startTime: null, endTime: null };
    }

    const startTimestamp = truncateDateToUTC12AMTime(startDate);
    const endTimestamp = startTimestamp + rangeDays * ONE_DAY_IN_MS;

    return {
        startTime: {
            seconds: Math.round(startTimestamp / 1000),
            nanos: 0,
        },
        endTime: {
            seconds: Math.round(endTimestamp / 1000),
            nanos: 0,
        },
    };
};
